// Use relative path for API in production (Vercel), or env variable for development
// In development, default to localhost:3000 (backend port)
// In production, use relative path which works with Vercel rewrites
const isDevelopment = import.meta.env.DEV || import.meta.env.MODE === 'development';
const defaultBackendUrl = isDevelopment ? 'http://localhost:3000' : '';

export const BASE_URL = import.meta.env.VITE_API_URL || defaultBackendUrl;
export const API_BASE_URL = BASE_URL ? `${BASE_URL}/api` : '/api';


